import { useMsal } from "@azure/msal-react";
import Button from '@mui/material/Button';
import { loginRequest } from "../authConfig";

const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    instance.loginPopup(loginRequest).catch((error) => {
      console.error(error);
    });
  }

  return (
    <Button variant="contained" className="ml-auto" onClick={() => handleLogin()}>Sign in</Button>
  );
}

export default SignInButton